import { useState } from "react";
import { Col, Container, Form, Offcanvas, Row } from "react-bootstrap";

const FilterQueryDataList = ({
  Show,
  Hide,
  Title,
  siteList,
  subjectList,
  eventList,
  siteId,
  setSiteId,
  subjectId,
  setSubjectId,
  eventId,
  setEventId,
  timePointId,
  setTimePointId,
  type,
  setType,
  status,
  setStatus,
  getStudyFormFieldQueryHistory
}) => {
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title} by selection</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container fluid>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>
                  Site:
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setSiteId(e.target.value)}>
                  <option value="">Select Site</option>
                  {siteList?.map(siteData => (
                    <option selected={siteId === siteData?.siteId} value={siteData?.siteId}>{siteData?.row?.SITEID}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>
                  Subject:
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setSubjectId(e.target.value)}  >
                  <option value="">Select Subject</option>
                  {subjectList?.map(subjectData => (
                    <option selected={subjectId === subjectData} value={subjectData?.subjectId}>{subjectData?.row?.SUBJECTID || subjectData?.row?.RANDOMNUMBER || subjectData?.row?.SCREENID}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>
                  Event:
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => {setEventId(e.target.value); setTimePointId(e.target[e.target.selectedIndex].id)}}  >
                  <option value="">Select Event</option>
                  {eventList?.map(eventData => (
                    <option selected={`${eventId}${timePointId || ""}` === `${eventData?.eventId}${eventData?.row?.TIMEPOINTUNIQUEID || ""}`} value={eventData?.eventId} id={eventData?.row?.TIMEPOINTUNIQUEID}>{eventData?.row?.EVENTID} {eventData?.row?.TIMEPOINTUNIQUEID && `(${eventData?.row?.TIMEPOINTID})`}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>
                  Query Type :
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setType(e.target.value)}  >
                  <option value="">Select Query Type</option>
                  <option selected={type === "manual"} value="manual">Manual Query</option>
                  <option selected={type === "auto"} value="auto">Auto Query</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>
                  Query Status :
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select onChange={(e) => setStatus(e.target.value)}  >
                  <option value="">Select Query Status</option>
                  <option selected={status === "open"} value="open">Open</option>
                  <option selected={status === "closed"} value="closed">Closed</option>
                  <option selected={status === "cancel"} value="cancel">Cancelled</option>
                </Form.Select>
              </Form.Group>
            </Row>
          </Container>
        </Offcanvas.Body>
        <div className="border-top p-2 bg-light text-end">
          <button onClick={getStudyFormFieldQueryHistory} className="updateProfile">Filter selection</button>
        </div>
      </Offcanvas>
    </>
  );
};

export default FilterQueryDataList;
